import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  SimpleGrid,
  VStack,
  Text,
  Button,
  useToast,
  Icon,
  List,
  ListItem,
  ListIcon,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Heading,
} from '@chakra-ui/react';
import { FaCheck, FaCrown, FaUser, FaUserTie } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

const SubscriptionSelect = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { updateSubscription } = useAuth();

  const plans = [
    {
      name: 'Free',
      price: '£0',
      icon: FaUser,
      color: 'gray.500',
      features: ['Basic property information', 'Limited 2 searched per 24 hours'],
      buttonText: 'Start Free',
      type: 'free',
    },
    {
      name: 'Explorer',
      price: 'Free',
      icon: FaUserTie,
      color: 'blue.500',
      features: [
        'Full property information Saved history with quick comparison',
        'Limited 6 searched per month',
      ],
      buttonText: 'Choose Standard',
      type: 'standard',
    },
    {
      name: 'Premium',
      price: 'Free - Introductory Offer',
      icon: FaCrown,
      color: 'purple.500',
      features: [
        'Full property information Saved history with quick comparison',
        'Limited 30 searched per month Print & Save options (including PDF format)',
      ],
      buttonText: 'Go Premium',
      type: 'premium',
    },
  ];

  const handleSelectPlan = async (planType) => {
    try {
      const response = await updateSubscription(planType);

      // Show success message with any additional info from the server
      toast({
        title: 'Subscription Updated',
        description:
          response.message ||
          `You've selected the ${planType.charAt(0).toUpperCase() + planType.slice(1)} plan`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      // Navigate home after a short delay to ensure the toast is visible
      setTimeout(() => navigate('/'), 1000);
    } catch (error) {
      toast({
        title: 'Subscription Update Failed',
        description: error.message || 'Failed to update subscription. Please try again.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Box bg='brand.background' minH='100vh' py={10}>
      <Container maxW='container.xl'>
        <VStack spacing={8} mb={10}>
          <Heading color='brand.text'>Choose Your Plan</Heading>
          <Text color='gray.600' fontSize='lg'>
            Select the plan that best fits your needs
          </Text>
        </VStack>

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10}>
          {plans.map((plan) => (
            <Card
              key={plan.name}
              variant='outline'
              bg='white'
              _hover={{ transform: 'translateY(-5px)', transition: 'transform 0.2s' }}
            >
              <CardHeader bg={plan.color} color='white' borderTopRadius='md' py={6}>
                <VStack>
                  <Icon as={plan.icon} boxSize={8} />
                  <Heading size='md'>{plan.name}</Heading>
                  {/*<Text fontSize='2xl' fontWeight='bold'>
                    {plan.price}
                  </Text>*/}
                </VStack>
              </CardHeader>

              <CardBody>
                <List spacing={3}>
                  {plan.features.map((feature, index) => (
                    <ListItem key={index}>
                      <ListIcon as={FaCheck} color={plan.color} />
                      {feature}
                    </ListItem>
                  ))}
                </List>
              </CardBody>

              <CardFooter>
                <Button
                  w='full'
                  colorScheme={
                    plan.name === 'Free' ? 'gray' : plan.name === 'Standard' ? 'blue' : 'purple'
                  }
                  onClick={() => handleSelectPlan(plan.type)}
                >
                  {plan.buttonText}
                </Button>
              </CardFooter>
            </Card>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default SubscriptionSelect;
